import { actionGenerator, IReduxAction } from '../../redux/actionGenerator';
import { IDepositAccountState } from '../../types/reducers/depositAccount';

export const UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS =
  'DEPOSIT_ACCOUNT :: UPDATE_RECOMMENDED_PACKAGE_PAYMENT_STATUS';

export type TUpdateDepositAccountRecommendedPackagePaymentStatusAction = IReduxAction<
  typeof UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS,
  IDepositAccountState['recommendedPackagePaymentStatus']
>;

export const updateDepositAccountRecommendedPackagePaymentStatus = actionGenerator<
  typeof UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS,
  IDepositAccountState['recommendedPackagePaymentStatus']
>(UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS);
